const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Featured products slider using Owl Carousel
 */
const OwlProductSlider = {

    init() {

        $('.feat-carousel').owlCarousel({
            loop:false,
            nav:true,
            responsive:{
                0:{
                    items:2,
                    margin:16,
                    stagePadding:12
                },
                640:{
                    items:3,
                    margin:20,
                    stagePadding:12
                },
                1024:{
                    items:4,
                    margin:32,
                    stagePadding:12
                },
                1280:{
                    items:4,
                    margin:64,
                    stagePadding:0
                }
            }
        });

        $('.feat-carousel .owl-nav').appendTo('.owl-nav__wrapper');
        $('.feat-carousel .owl-dots').remove();
        $('.owl-nav__wrapper .owl-next span, .owl-nav__wrapper .owl-prev span' ).text('');

        $('.prod-gallery-carousel').owlCarousel({
            loop:false,
            nav:true,
            items:1
        });

        $('.prod-gallery-carousel .owl-nav').appendTo('.prod-nav__wrapper');
        $('.prod-gallery-carousel .owl-dots').remove();
        $('.prod-nav__wrapper  .owl-next span, .prod-nav__wrapper .owl-prev span' ).text('');

        $('.timeline-carousel').owlCarousel({
            loop:false,
            nav:true,
            margin:0,
            autoWidth:true
        });

        $('.timeline-carousel .owl-nav').appendTo('.timeline-nav__wrapper');
        $('.timeline-carousel .owl-dots').remove();
        $('.timeline-nav__wrapper .owl-next span, .timeline-nav__wrapper .owl-prev span' ).text('');        

    }

};

export default OwlProductSlider;